import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'suraReplaceUnderscore',
    standalone: false
})
export class ReplaceUnderscorePipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    return value ? value.replace(/_/g, ' ') : '';
  }

}
